import { store } from '@sonifi/wb-core/store/store';
import { initHotelDirectory } from '../services/hd.service';
import { redirect } from 'react-router';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { getInicialNode } from '../services/helpers/hdHelper';
import { setNodePreviewSelected } from '../store/hotelDirectorySlice';

export async function loaderHotelDirectory({ params }) {
  const { groupId, platform, id } = params;

  const nodeId = await store.dispatch(
    initHotelDirectory({
      groupId: parseInt(groupId),
      id,
      platform,
    }),
  );

  if (nodeId) {
    return redirect(`${nodeId}`);
  }

  return {};
}

export async function loaderHotelDirectoryNodeId({ params }) {
  const { groupId, platform, id } = params;
  const nodeId = parseInt(id);

  const {
    hotelDirectory: { loading, nodePreviewSelected, compendiaMenu },
  } = store.getState();

  if (loading !== LOADING_STATUS.success) {
    await store.dispatch(
      initHotelDirectory({
        groupId: parseInt(groupId),
        id,
        platform,
      }),
    );
  } else if (nodePreviewSelected?.id !== nodeId) {
    const node = getInicialNode({ id: nodeId, menu: compendiaMenu.menu });
    store.dispatch(setNodePreviewSelected({ node }));
  }

  return {};
}
